import WalletConnectProvider from "@walletconnect/web3-provider";

const getAllWalletConnectProviderOption = () => {
    return {
        walletconnect : {
            package: WalletConnectProvider,
            options: {
                infuraId: import.meta.env.VITE_INFURA_KEY
            }
        }
    }
}

const getSpecificWalletConnectProviderOption = (desktop, mobile) => {
    return {
        walletconnect : {
            package: WalletConnectProvider,
            options: {
                infuraId: import.meta.env.VITE_INFURA_KEY,
                qrcodeModalOptions: {
                    desktopLinks: desktop,
                    mobileLinks: mobile
                }
            }
        }
    }
}

export {
    getAllWalletConnectProviderOption,
    getSpecificWalletConnectProviderOption,
}

